import { httpClient } from "common/HttpClient/http-client";

const CONTEXT_IMPORT_BASE = "/platform-admin-service/v1/imports/context-nodes";

export const CONTEXT_IMPORT_VALIDATE_PATH = `${CONTEXT_IMPORT_BASE}?mode=validate`;
export const CONTEXT_IMPORT_SYNC_PATH = `${CONTEXT_IMPORT_BASE}?mode=sync`;

export const CONTEXT_IMPORT_MAX_BYTES = 15 * 1024 * 1024;

export function postContextImportValidate(formData) {
  return httpClient.post(CONTEXT_IMPORT_VALIDATE_PATH, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function postContextImportSync(formData) {
  return httpClient.post(CONTEXT_IMPORT_SYNC_PATH, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
